import React, { Component } from 'react';

export default class NavButton extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {
        }

        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() { }

    componentWillReceiveProps() { }

    handleClick() {
        if (this.props.overrideFunction === undefined) {
            if (this.props.pageName != '') {
                this.props.changePage(this.props.pageName);
            } else {
                this.props.logout();
            }
        } else {
            this.props.overrideFunction();
        }
    }

    render() {

        let isGreen = this.props.pageName === window.location.hash.substring(2);
        let outerClass = "navbutton-container";
        let iconClass = "navbutton-icon material-icons";
        let titleClass = "navbutton-title";
        if (isGreen) {
            outerClass += " active"
            iconClass += " navbutton--active";
            titleClass += " navbutton--active"
        }

        return (
            <div data-trackid={'nav-'+this.props.pageName} onClick={!isGreen ? this.handleClick : null} className={outerClass}>
                <div className={iconClass}>{this.props.icon}</div>
                <div className={titleClass}>{this.props.title}</div>
            </div>
        );
    }
}
